/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { Button, List, Checkbox, message, Spin, Tag } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import { withUser } from "pages/context/user";
import { loginAfterUrl } from 'pages/config'
import { withCompanySetting } from 'pages/context/companySetting'
import { setCompanyId, assignStyleCompanyId } from 'apis/user'
import * as qs from "query-string";
import cookies from "js-cookie";

import "./index.css";

import userSelf from "pages/user";
import manager from "pages/manager";
import Authentication from '../authentication/alert'

const { axios } = window;

const SelectList = withCompanySetting(function SelectList({ companySetting, user, list , setVisible , setRzCommanyId}) {
  const { domainId } = qs.parse(window.location.search);
  // const [data, setData] = useState([]);
  //  设置风格企业ID
  const setStyleID = (id) => {
    assignStyleCompanyId(id).then(res => {
      if (!res) {
        setStyleID(id);
      }
    });
  };
  // 如果不是定制的 就传0
  function setCompany(company) {
    if (company.effect) {
      setStyleID(company.companyId, cookies.get('shorcuts'))
    } else {
      setStyleID(0, cookies.get('shorcuts'))
    }
    // alert(JSON.stringify(company))
    setCompanyId({ companyId: company.companyId })
    cookies.remove("noInWorkBol");
    user.dispatch({ type: 'set-current-company', payload: company });
    companySetting.dispatch({ type: 'init' });
    // 存储管理员类别
    sessionStorage.setItem("adminType", company.owner)
  }
  // 企业认证
  const authenticationFn = (e,info) =>{
    e.stopPropagation()
    setRzCommanyId(info.companyId)
    setVisible(true)
  }
  if (!list.length) {
    return <Redirect to={{ pathname: userSelf.startPage }} />;
  }
  if (list.length === 1) {
    setCompany(list[0]);
    return null
  }
  // useEffect(() => {
  //   getCompanyId().then(data => {
  //     if(data.id!==0){
  //       const companyData={
  //         companyId:data.id,
  //         companyName:data.name,
  //         logo:data.logo,
  //       }
  //       setCompanyId({companyId : data.id})
  //       user.dispatch({ type: 'set-current-company', payload: companyData });
  //       companySetting.dispatch({type : 'init'});
  //     }
  //   });
  // }, []);
  return (
    <List className="company-box hover" header={<div>请选择本次登录的企业</div>}>
      {list.map(p => (
        <List.Item
          key={p.companyId}
          onClick={() => {
            setCompany(p)
            cookies.remove("dingzhiBol");
            cookies.remove("jiluCompanyid");
          }}
        >
          <img src={p.logo} alt="logo" />
          <p>{p.companyName} {p.joinFlag && (<Tag color="volcano">新加入的企业</Tag>)}</p>
          {!p.identify && p.owner === 1 && (<a style={{position : "absolute", right : 40}}  onClick={e => authenticationFn(e,p)}>企业认证</a>)}
          <RightOutlined />
        </List.Item>
      ))}
      <List.Item key="info">
        <a href="javaScript:;" onClick={() => {
          setCompanyId({ companyId: 0 }).then(() => {
            cookies.remove("dingzhiBol");
            // window.location.href = `user/workbench/home?companyid=0${domainId ? `&domainId=${domainId}` : ''}`
            window.location.href = `${loginAfterUrl()}&companyid=0${domainId ? `&domainId=${domainId}` : ''}`
          })
        }}>不登录企业，以个人用户登录</a>
      </List.Item>
      <List.Item key="empty" />
    </List>
  );
})

function MultiInvitation({ data, onChanged }) {
  const ref = useRef(new Set());

  function onChange(id, e) {
    const set = ref.current;
    e.target.checked ? set.add(id) : set.delete(id);
    onChanged([...set]);
  }

  const arr = data.map(item => (
    <List.Item key={item.staffId}>
      <img src={item.logo} alt="logo" />
      <p>{item.companyName}</p>
      <Checkbox onChange={onChange.bind(null, item.staffId)} />
    </List.Item>
  ));
  arr.push(<List.Item key="empty" />);
  return arr;
}

function SignleInvitation({ data, onChanged }) {
  return (
    <div className="signle">
      <img src={data.logo} alt="logo" />
      <p>{data.companyName}</p>
    </div>
  );
}

function errorFilter(status, data, next) {
  if (status !== 200) {
    message.error(data.message, 5);
    return;
  }
  next && next();
}

function Invitation({ list, cb }) {
  const [ids, setId] = useState([]);
  const [loading, setLoading] = useState(false);

  const signle = list.length === 1;

  function onChanged(arr) {
    setId(arr);
  }

  async function forInvitation(join) {
    setLoading(true);
    let accepts, rejects
    if (join) {
      accepts = signle ? [list[0].staffId] : ids;
      if (accepts.length === list.length) {
        rejects = [];
      } else {
        rejects = list
          .filter(p => !accepts.some(id => id === p.staffId))
          .map(p => p.staffId);
      }
    } else {
      accepts = []
      rejects = list.map(p => p.staffId);
    }

    // console.log('rejects', rejects)
    if (accepts.length) {
      const { status, data } = await axios.put(`/staff/batch/join`, null, {
        params: {
          staffs: accepts.join(",")
          // Array.from({ length: 50 }, (x, i) => i).join(',')
        }
      });
      if (status !== 200) {
        message.error(data.message, 5);
        setLoading(false);
        return;
      }
    }
    if (rejects.length) {
      const { status, data } = await axios.put(`/staff/batch/refuse`, null, {
        params: {
          staffs: rejects.join(",")
          // Array.from({ length: 50 }, (x, i) => i).join(',')
        }
      });
      if (status !== 200) {
        message.error(data.message, 5);
        setLoading(false);
        return;
      }
    }
    setLoading(false);
    cb(accepts);
  }

  return (
    <div className="company-box">
      <List header={<div>以下企业邀请您加入</div>}>
        {signle ? (
          <SignleInvitation data={list[0]} />
        ) : (
            <MultiInvitation data={list} onChanged={onChanged} />
          )}
      </List>
      <div className="button-group">
        <Button
          block
          type="primary"
          disabled={!signle && !ids.length}
          loading={loading}
          onClick={() => forInvitation(true)}
        >
          加入{signle ? "该" : "所选"}企业
        </Button>
        <Button
          block
          type="link"
          loading={loading}
          onClick={() => forInvitation(false)}
        >
          不加入{signle ? "该" : "以上全部"}企业 &gt;
        </Button>
      </div>
    </div>
  );
}

export default withUser(function CompanyBox({ user }) {
   // 控制企业认证弹窗
  const [visible, setVisible] = useState(false);
  // 打开认证弹窗企业id
  const [rzCommanyId, setRzCommanyId] = useState(null);
  const { domainId } = qs.parse(window.location.search);
  // const [invitationList, setInvitation] = useState(user.self.myInvitations);
  const invitationList = user.self.myInvitations
  // const [joinedList, setJoined] = useState(user.self.myCompanys);
  const joinedList = user.self.myCompanys

  // 禁止访问该页面
  if (user.self.qingyan) {
    return <Redirect to={{ pathname: manager.startPage }} />;
  }
  let curr;
  // 已选择了企业
  if (user.self.company && !cookies.get("noInWorkBol")) {
    // console.log("88", `${loginAfterUrl()}&companyid=${user.self.company.companyId}${domainId ? `&domainId=${domainId}` : ''}`)
    // return <Redirect to={`/user/workbench/home?companyid=${user.self.company.companyId}${domainId ? `&domainId=${domainId}` : ''}`} />;
    window.location.href = `${loginAfterUrl()}&companyid=${user.self.company.companyId}${domainId ? `&domainId=${domainId}` : ''}`
    // curr = `当前选择的是：${user.self.company.companyName}`
  }
  // 尚未初始化
  else if (!invitationList.length && !joinedList.length) {
    // curr = null;
    // return <Redirect to={'/user/workbench/home'} />;
    return <Redirect to={loginAfterUrl()} />;
  }
  // 先处理邀请
  else if (invitationList.length) {
    curr = (
      <Invitation
        list={invitationList}
        cb={joinedIds => {
          user.dispatch({
            type: 'set-current-user',
            payload: {
              myCompanys: joinedIds.length ?
                joinedList.concat(invitationList.filter(p =>
                  joinedIds.some(id => id === p.staffId)
                )) :
                joinedList,
              myInvitations: [],
            }
          });
        }}
      />
    );
  }
  // 选择企业
  else {
    curr = <SelectList user={user} list={joinedList} setVisible={setVisible} setRzCommanyId={setRzCommanyId} />;
  }
  return (
    <section className="page-box">
       {visible && (
        <Authentication
          visible={visible}
          onClose={() => {
            setVisible(false);
          }}
          title="企业认证"
          companyId={rzCommanyId}
        />
      )}
      <Spin spinning={false}>{curr}</Spin>
    </section>
  );
});
/* eslint-disable */
